export { default } from 'Components/Shops/Shops'
